import { Boxes, Workflow, Check, ArrowRight } from "lucide-react";
import { useI18n } from "../i18n/i18n";

const ICONS = [Boxes, Workflow];

export default function Products() {
  const { t } = useI18n();
  const items = t("products.items");

  const scrollToContact = () => {
    const el = document.getElementById("contact");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section
      id="products"
      data-testid="products-section"
      className="relative py-24 md:py-32 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-14">
        <div className="max-w-3xl mb-16">
          <p className="cs-overline mb-4">{t("products.overline")}</p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-white leading-tight">
            {t("products.title")}
          </h2>
          <p className="text-slate-400 mt-5 text-base lg:text-lg leading-relaxed">
            {t("products.subtitle")}
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-8">
          {items.map((item, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <div
                key={i}
                className="cs-card p-8 lg:p-10 flex flex-col"
                data-testid={`product-card-${i}`}
              >
                <div className="flex items-center justify-between gap-3 mb-7">
                  <div className="h-12 w-12 rounded-lg bg-sky-400/10 border border-sky-400/30 flex items-center justify-center shrink-0">
                    <Icon className="w-6 h-6 text-sky-400" strokeWidth={1.6} />
                  </div>
                  <div className="flex flex-wrap items-center gap-2 justify-end">
                    {item.tags.map((tag, k) => (
                      <span
                        key={k}
                        className="text-[10px] font-semibold uppercase tracking-[0.22em] text-sky-400/90 px-2.5 py-1 rounded-full border border-sky-400/30"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>

                <h3 className="font-display text-2xl lg:text-[28px] text-white leading-snug">
                  {item.title}
                </h3>
                <p className="text-slate-400 text-[15px] mt-4 leading-relaxed">
                  {item.desc}
                </p>

                <div className="cs-divider my-7" />

                <ul className="space-y-3">
                  {item.points.map((p, j) => (
                    <li
                      key={j}
                      className="flex items-start gap-3 text-[15px] text-slate-200"
                    >
                      <span className="mt-1.5 h-1.5 w-1.5 rounded-full bg-sky-400 shrink-0" />
                      <span>{p}</span>
                    </li>
                  ))}
                </ul>

                <button
                  onClick={scrollToContact}
                  className="mt-8 inline-flex items-center gap-2 text-sm text-sky-400 hover:text-sky-300 self-start cs-link-underline"
                  data-testid={`product-cta-${i}`}
                >
                  {t("products.cta")} <ArrowRight className="w-4 h-4" />
                </button>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
